import { makeRequest, CommonRequestOptions } from '../makeRequest';

export async function bulkCancelQuizSession(
   quiz_sessionids: number[],
   { ...common }: CommonRequestOptions = {}
) {
   return makeRequest('post', '/quizzes/sessions/bulkCancel', {
      ...common,
      body: { quiz_sessionids },
   });
}
